/**
 *  时间格式处理
 */

export default class DateUtil {

  /**
   * 返回指定格式的时间格式
   * @param format
   */
  static get (fmt) {
    let date = new Date()
    return date.format(fmt)
  }

  /**
   * 短日期格式
   * @returns {string}
   */
  static getDate () {
    let date = new Date()
    return date.format('yyyy-MM-dd 00:00:00')
  }

  /**
   * 长日期格式
   * @returns {string}
   */
  static getDateTime () {
    let date = new Date()
    return date.format('yyyy-MM-dd hh:mm:ss')
  }

  /**
   * 字符串转日期
   * @param value
   * @returns {Date}
   */
  static convert (value) {
    if (!value) return new Date()
    var _value = value.toString()
    _value = _value.replace(/-/g, '/')
    // _value =  _value.replace("T"," ");
    var _date = new Date(_value)
    return _date
  }

  /**
   * 前日期是今年的第多少天
   * @returns {number}
   * @private
   */
  static getDayOfYear () {
    var dateArr = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31)
    var date = new Date()
    var day = date.getDate()
    var month = date.getMonth() //getMonth()是从0开始
    var year = date.getFullYear()
    var result = 0
    for (var i = 0; i < month; i++) {
      result += dateArr[i]
    }
    result += day
    //判断是否闰年,2月多加1天
    if (month > 1 && (year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
      result += 1
    }
    return result
  }

  /***
   * 相差天数
   * @param value
   * @returns {number}
   */
  static dateDiffDays (value) {
    value = this.convert(value)
    let _ts = this.convert(this.getDateTime()) - value
    var _days = Math.floor(_ts / (24 * 3600 * 1000))
    return _days
  }

  /**
   * 是否是当天
   * @param value
   * @returns {boolean}
   */
  static isOneDay (value) {
    return this.convert(value).format('yyyy-MM-dd') === new Date().format('yyyy-MM-dd')
  }

  /**
   * 返回相差的小时数
   */
  static dateDiffHours (value) {
    value = this.convert(value)
    let _ts = this.convert(this.getDateTime()) - value
    var _millisecond = _ts % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var _hours = Math.floor(_millisecond / (3600 * 1000))
    return _hours
  }

//----end
}

Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,                 //月份
    'd+': this.getDate(),                    //日
    'h+': this.getHours(),                   //小时
    'm+': this.getMinutes(),                 //分
    's+': this.getSeconds(),                 //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    'S': this.getMilliseconds()             //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  return fmt
}


// WEBPACK FOOTER //
// ./src/wbap-utils/DateUtil/index.js